module.exports = __webpack_public_path__ + "img/coin-category.8e9d71a4.svg";